import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/especialidades.css";
import EspecialidadesSummary from "../components/EspecialidadesSummary";
import EspecialidadesTable from "../components/EspecialidadesTable";
import EspecialidadesFormModal from "../components/EspecialidadesFormModal";
import CoordinacionTabs from "../../catalogo/components/CoordinacionTabs";
import { usePermissions } from "../../../../utils/permissions";

export default function EspecialidadesView({
  especialidades,
  niveles,
  loading,
  nivelesLoading,
  listError,
  nivelesError,
  resumen,
  filtro,
  aplicarFiltro,
  lastUpdated,
  reload,
  reloadNiveles,
  modal,
  especialidadSeleccionada,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  abrirModalNuevo,
  abrirModalEditar,
  abrirModalEliminar,
  cerrarModal,
  handleCrearEspecialidad,
  handleActualizarEspecialidad,
  handleEliminarEspecialidad,
}) {
  const { hasPermission } = usePermissions();
  const canCreateEspecialidad = hasPermission("especialidades.crear");
  const canUpdateEspecialidad = hasPermission("especialidades.actualizar");
  const canDeleteEspecialidad = hasPermission("especialidades.eliminar");

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (modal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modal]);

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronizacion inicial";

  return (
    <section className="management-page management-theme-violet especialidades-wrapper">
      <CoordinacionTabs />
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Academico</p>
          <h4 className="management-title mb-1">Especialidades</h4>
          <p className="text-muted mb-0">Gestiona las especialidades y sus niveles requeridos.</p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreateEspecialidad && (
            <button type="button" className="btn management-btn-primary" onClick={abrirModalNuevo}>
              <i className="bi bi-plus-circle me-2" />
              Nueva especialidad
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <EspecialidadesSummary resumen={resumen} onQuickFilter={aplicarFiltro} activeKey={filtro} />

      {(listError || nivelesError) && (
        <div className="management-alert d-flex align-items-center justify-content-between gap-3 flex-wrap">
          <div>
            {listError && <p className="mb-1">{listError}</p>}
            {nivelesError && <p className="mb-0">Niveles: {nivelesError}</p>}
          </div>
          <div className="d-flex gap-2 flex-wrap">
            {listError && (
              <button type="button" className="btn btn-sm btn-primary" onClick={reload}>
                Reintentar datos
              </button>
            )}
            {nivelesError && (
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={reloadNiveles}>
                Reintentar niveles
              </button>
            )}
          </div>
        </div>
      )}

      <EspecialidadesTable
        especialidades={especialidades}
        loading={loading}
        reload={reload}
        onEdit={canUpdateEspecialidad ? abrirModalEditar : undefined}
        onDelete={canDeleteEspecialidad ? abrirModalEliminar : undefined}
        canEdit={canUpdateEspecialidad}
        canDelete={canDeleteEspecialidad}
      />

      <EspecialidadesFormModal
        modal={modal}
        formNuevo={formNuevo}
        setFormNuevo={setFormNuevo}
        formEditar={formEditar}
        setFormEditar={setFormEditar}
        savingNuevo={savingNuevo}
        savingEditar={savingEditar}
        deleting={deleting}
        especialidadSeleccionada={especialidadSeleccionada}
        cerrarModal={cerrarModal}
        handleCrearEspecialidad={handleCrearEspecialidad}
        handleActualizarEspecialidad={handleActualizarEspecialidad}
        handleEliminarEspecialidad={handleEliminarEspecialidad}
        niveles={niveles}
        nivelesLoading={nivelesLoading}
        canUpdate={canUpdateEspecialidad}
        canDelete={canDeleteEspecialidad}
      />
    </section>
  );
}
